import React from "react";
import { Link } from "react-router-dom";
import check from "../../../imagenes/thanks/check.png";
import check2x from "../../../imagenes/thanks/check@2x.png";
import cruz from "../../../imagenes/thanks/cruz.png";
import cruz2x from "../../../imagenes/thanks/cruz@2x.png";
import imgSmall from "../../../imagenes/sobrePedraza/img-small-2.png";
import imgSmall2x from "../../../imagenes/sobrePedraza/img-small-2@2x.png";
import LayoutCompra from "../../Global/LayoutCompra";
import get from "../../../utils/get";

const FinalizacionCdr = (props) => {
  const numeroReserva = get(props, 'match.params.numeroReserva', 0);
  const estado = get(props, 'match.params.estado', null);

  // const tipoCliente = sessionStorage.getItem("tipoCliente");
  /*
  const [state, ] = useContext(GlobalContext);
  const { setCantidadReservas } = state || {}; //useGlobal();
  useEffect(() => {
    traerReservasPorUsuario(props, token, setCantidadReservas);
  }, [token]);
  */

  let texto = "En las próximas horas verá reflejado el pago realizado a través de su tarjeta de crédito.";
  let texto2 = "La presente reserva tiene vencimiento de pago";
  let texto3 = "Muchas gracias por su compra";
  let texto4 = "exitosa";
  let resultado = true;

  switch (estado) {
    case "error":
      resultado = false;
      texto3 = "Pendiente de Pago";
      texto4 = "pendiente";
      texto = "Detectamos que no ha concluido el pago.";
      texto2 =
        "Su reserva ha sido generada pero falta abonarla. Si desea puede llamar a nuestras oficinas para mas información o puede abonarla ingresando desde el panel 'Mis Reservas'.";
      break;
    case "pendiente":
      resultado = false;
      texto3 = "Compra Pendiente";
      texto4 = "pendiente";
      texto = "Su pago está PENDIENTE";
      texto2 =
        "Su reserva ha sido generada pero falta abonarla. Si desea puede llamar a nuestras oficinas para mas información o puede abonarla ingresando desde el panel 'Mis Reservas'.";
      break;
    default:
      break;
  }

  return (
    <LayoutCompra paso="4">
    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 thanks clearfix">
      {resultado ? (
        <img
          src={check}
          alt="Icono de un check"
          srcSet={check + " 1x, " + check2x + " 2x"}
        />
      ) : (
        <img
          src={cruz}
          alt="Icono de un check"
          srcSet={cruz + " 1x, " + cruz2x + " 2x"}
        />
      )}
      <h2 className={resultado ? "mensajeExito" : "mensajeError"}>{texto3}</h2>
      <div className="compra-resumen">
        <div className="img-container">
          <img
            src={imgSmall}
            alt="Imagen de fondo acerca de viajes"
            srcSet={imgSmall + " 1x, " + imgSmall2x + " 2x"}
          />
        </div>
        <div className="txt-container">
          <h6>compra {texto4}</h6>
          <h3>
            su n° de reserva es: <strong>{numeroReserva}</strong>
          </h3>
          <p>{texto2}</p>
          <p>{texto}</p>
          <p>
            <strong>
              Podr&aacute;s ver tus reservas desde la opci&oacute;n{" "}
            </strong>
            <Link to={`/panel-mis-reservas/`}>Mis Reservas</Link>
          </p>
        </div>
      </div>
      <br />
      <Link to="/" className="submitCargaPasajeros">
        Finalizar
      </Link>
    </div>
    </LayoutCompra>
  );
};

export default FinalizacionCdr;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/FinalizacionCdr.js